import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { IndicatorsSearchToolbarModel } from '../../../models/indicators-search-toolbar-model.model';
import { ApiMethods, PermissionConfiguration } from '../../../models/permission.model';
import { QFilterModel } from '../../../models/qfilter.model';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../models/search-toolbar-factory-parameters.model';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { SearchToolbarModelFactoryService } from '../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { PermsService } from '../../../services/utils/perms.service';
import { CustomerCategoryImportanceComponent } from './customer-category-importance/customer-category-importance.component';
import { CustomerDivisionExpenseComponent } from './customer-division-expense/customer-division-expense.component';
import { CustomerEvolutionComponent } from './customer-evolution/customer-evolution.component';
import { CustomerFairShareComponent } from './customer-fair-share/customer-fair-share.component';
// import { CustomerValueCateogoriesRelevanceComponent } from './customer-value-cateogories-relevance/customer-value-cateogories-relevance.component';
import { CustomerValueDetailComponent } from './customer-value-detail/customer-value-detail.component';
import { CustomerValueOverviewComponent } from './customer-value-overview/customer-value-overview.component';

@Component ({
  selector: 'app-customer-value',
  templateUrl: 'customer-value.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./customer-value.css']
})

// Pagina 17 - Pagina 18
export class CustomerValueComponent implements OnInit {
  @ViewChild(CustomerEvolutionComponent) evolution: CustomerEvolutionComponent;
  @ViewChild(CustomerFairShareComponent) fairShare: CustomerFairShareComponent;
  @ViewChild(CustomerDivisionExpenseComponent) divisionExpense: CustomerDivisionExpenseComponent;
  @ViewChild(CustomerCategoryImportanceComponent) categoryImportance: CustomerCategoryImportanceComponent;
  @ViewChild(CustomerValueDetailComponent) detail: CustomerValueDetailComponent;
  @ViewChild(CustomerValueOverviewComponent) overview: CustomerValueOverviewComponent;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public data: QFilterModel;

  types: MenuItem[];
  oldData: any;
  activeIndex: number;


  /********************** PERMESSI UTENTE *************************/

  // Visualizza tab Overview
  public clientiValoreOverviewPerm: boolean;
  public clientiValoreOverviewPermCheck: PermissionConfiguration;

  // Visualizza tab Dettaglio
  public clientiValoreDettaglioPerm: boolean;
  public clientiValoreDettaglioPermCheck: PermissionConfiguration;

  // Visualizza tab Fair Share
  public clientiValoreSharePerm: boolean;
  public clientiValoreSharePermCheck: PermissionConfiguration;

  // Visualizza tab Ripartizione Spesa
  public clientiValoreSpesaPerm: boolean;
  public clientiValoreSpesaPermCheck: PermissionConfiguration;

  // Visualizza tab Importanza Categorie
  public clientiValoreCategoriePerm: boolean;
  public clientiValoreCategoriePermCheck: PermissionConfiguration;

  // Visualizza tab Evoluzione Clientela
  public clientiValoreEvoPerm: boolean;
  public clientiValoreEvoPermCheck: PermissionConfiguration;

  /****************************************************************/


  constructor(
    private translate: TranslateService,
    private svcAnalytics: AnalyticsService,
    private srvPerms: PermsService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) {
    this.clientiValoreOverviewPermCheck = {
      ms_base: 'koncentro-analytics',
      operation: 'clienti-valore-overview',
      method: ApiMethods.GET
    };
    this.clientiValoreDettaglioPermCheck = {
      ms_base: 'koncentro-analytics',
      operation: 'clienti-valore-dettaglio',
      method: ApiMethods.GET
    };
    this.clientiValoreSharePermCheck = {
      ms_base: 'koncentro-analytics',
      operation: 'clienti-valore-share',
      method: ApiMethods.GET
    };
    this.clientiValoreSpesaPermCheck = {
      ms_base: 'koncentro-analytics',
      operation: 'clienti-valore-spesa',
      method: ApiMethods.GET
    };
    this.clientiValoreCategoriePermCheck = {
      ms_base: 'koncentro-analytics',
      operation: 'clienti-valore-categorie',
      method: ApiMethods.GET
    };
    this.clientiValoreEvoPermCheck = {
      ms_base: 'koncentro-analytics',
      operation: 'clienti-valore-evo',
      method: ApiMethods.GET
    };

  }

  ngOnInit(): void {
    this.types = [];
    this.translate.get([
      'customerShoppingHabits.customerData',
      'customerShoppingHabits.details',
      'customerShoppingHabits.fairShare',
      'customerShoppingHabits.divisionExpense',
      'customerShoppingHabits.categoryImportance',
      'customerShoppingHabits.evolution',
    ]).subscribe(res => {

      const searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
      searchParams.svcAnalytics = this.svcAnalytics;
      searchParams.dateFunctionType = SearchToolbarDateFunction.CsDates;
      searchParams.finestra = SearchToolbarFilterWindow.Month;
      searchParams.raggruppamento = SearchToolbarFilterGrouping.All;
      searchParams.disabledSections = [SearchToolbarSection.CardModes];

      this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
        this.searchModel = model;
      });

      // Permissions
      this.activeIndex = 0;
      Observable.zip(
        this.srvPerms.check(this.clientiValoreOverviewPermCheck),
        this.srvPerms.check(this.clientiValoreDettaglioPermCheck),
        this.srvPerms.check(this.clientiValoreSharePermCheck),
        this.srvPerms.check(this.clientiValoreSpesaPermCheck),
        this.srvPerms.check(this.clientiValoreCategoriePermCheck),
        this.srvPerms.check(this.clientiValoreEvoPermCheck)
      ).subscribe(([clientiValoreOverview, clientiValoreDettaglio, clientiValoreShare, clientiValoreSpesa,
                                   clientiValoreCategorie, clientiValoreEvo ]) => {
        console.log('PERMISSION');
        this.clientiValoreOverviewPerm = clientiValoreOverview ;
        this.clientiValoreDettaglioPerm = clientiValoreDettaglio ;
        this.clientiValoreSharePerm = clientiValoreShare ;
        this.clientiValoreSpesaPerm = clientiValoreSpesa ;
        this.clientiValoreCategoriePerm = clientiValoreCategorie ;
        this.clientiValoreEvoPerm = clientiValoreEvo ;
        console.log('clientiValoreOverview', clientiValoreOverview, this.clientiValoreOverviewPerm);

        this.types.push(
          {
            label: res['customerShoppingHabits.customerData'],
            command: (event: any) => {
              this.activeIndex = 0;
            },
            disabled: !this.clientiValoreOverviewPerm
          },
          {
            label: res['customerShoppingHabits.details'],
            command: (event: any) => {
              this.activeIndex = 1;
            }, disabled: !this.clientiValoreDettaglioPerm
          },
          {
            label: res['customerShoppingHabits.fairShare'],
            command: (event: any) => {
              this.activeIndex = 2;
            }, disabled: !this.clientiValoreSharePerm
          },
          {
            label: res['customerShoppingHabits.divisionExpense'],
            command: (event: any) => {
              this.activeIndex = 3;
            }, disabled: !this.clientiValoreSpesaPerm
          },
          {
            label: res['customerShoppingHabits.categoryImportance'],
            command: (event: any) => {
              this.activeIndex = 4;
            }, disabled: !this.clientiValoreCategoriePerm
          },
          {
            label: res['customerShoppingHabits.evolution'],
            command: (event: any) => {
              this.activeIndex = 5;
            }, disabled: !this.clientiValoreEvoPerm
          },
        );

        for (let index in this.types) {
          if (!this.types[index].disabled) {
            this.activeIndex = +index;
            break;
          }
        }
      });

    });
  }

  applyResult(data) {
    const isDataEquals = JSON.stringify(this.oldData) === JSON.stringify(data);

    switch (this.activeIndex) {
      case 0:
        if (!isDataEquals) {
          this.detail.resetData();
          this.fairShare.resetData();
          this.evolution.resetData();
          this.divisionExpense.resetData();
          this.categoryImportance.resetData();
        }

        this.overview.showResult(data);
        break;
      case 1:
        if (!isDataEquals) {
          this.overview.resetData();
          this.fairShare.resetData();
          this.evolution.resetData();
          this.divisionExpense.resetData();
          this.categoryImportance.resetData();
        }

        this.detail.searchValueTrend(data);
        break;
      case 2:
        if (!isDataEquals) {
          this.overview.resetData();
          this.detail.resetData();
          this.evolution.resetData();
          this.divisionExpense.resetData();
          this.categoryImportance.resetData();
        }

        this.fairShare.setClusterList(this.searchModel.cluster_list);
        this.fairShare.searchValueTrend(data);
        break;
      case 3:
        if (!isDataEquals) {
          this.overview.resetData();
          this.detail.resetData();
          this.fairShare.resetData();
            this.evolution.resetData();
            this.categoryImportance.resetData();
        }

        this.divisionExpense.searchValueCustomer(data);
        break;
      case 4:
        if (!isDataEquals) {
          this.overview.resetData();
          this.detail.resetData();
          this.fairShare.resetData();
            this.evolution.resetData();
            this.divisionExpense.resetData();
        }

        this.categoryImportance.searchValueCustomer(data);
        break;
     case 5:
        if (!isDataEquals) {
          this.overview.resetData();
          this.detail.resetData();
          this.fairShare.resetData();
          this.divisionExpense.resetData();
          this.categoryImportance.resetData();
        }

        this.evolution.searchValueTrend(data);
        break;
    }

    this.oldData = { ...data };
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-value.component.ts